import SvgWrapper from './SvgWrapper';
import { AllergnIconProps } from './types';

const CrustaceanIcon = ({
  innerColor = '#fefefe',
  outerColor = '#00a1db',
  ...props
}: AllergnIconProps) => {
  return (
    <SvgWrapper {...props}>
      <g
        id="Grupo_117"
        data-name="Grupo 117"
        transform="translate(-315.5 -2094)"
      >
        <g
          id="Rectángulo_22"
          data-name="Rectángulo 22"
          transform="translate(315.5 2094)"
          fill="#fff"
          stroke="#000"
          stroke-width="1"
        >
          <rect width="27" height="27" rx="2" stroke="none" />
          <rect x="0.5" y="0.5" width="26" height="26" rx="1.5" fill="none" />
        </g>
        <g id="prawn" transform="translate(322.458 2099.989)">
          <path
            id="Trazado_9102"
            data-name="Trazado 9102"
            d="M11.131.266,10.464,0H9.933V1.211H9.449V3.006a1.7,1.7,0,0,0,.224.841l.293.514H9.353a1.868,1.868,0,0,0-1.181.423,2.183,2.183,0,0,0-.42-.847V2.724A2.225,2.225,0,0,1,8.408,1.14L8.066.8a2.708,2.708,0,0,0-.8,1.926v.629l-.143-.172a.755.755,0,0,0-.341-.229V0H6.3V2.952a.756.756,0,0,0-.341.229l-.143.172V2.724A2.707,2.707,0,0,0,5.017.8l-.343.343A2.225,2.225,0,0,1,5.33,2.724V3.936a2.183,2.183,0,0,0-.42.847A1.868,1.868,0,0,0,3.73,4.361H3.117l.293-.514a1.7,1.7,0,0,0,.224-.841V1.211H3.15V0H2.619L1.952.266A3.09,3.09,0,0,0,0,3.15,3.15,3.15,0,0,0,3.15,6.3h1.7v.242a.727.727,0,0,0,.458.674,1.05,1.05,0,0,0-.206.537H3.989l-.556.835.4.269.413-.619H5.1a1.056,1.056,0,0,0,.165.485,1.056,1.056,0,0,0-.165.485H3.989l-.556.835.4.269.413-.619H5.1a1.056,1.056,0,0,0,.3.656l.018.015a1.208,1.208,0,0,0-.574,1.025V12.6h.242A1.69,1.69,0,0,0,6.3,12.087v1H5.815v1.938H7.268V13.083H6.784v-1A1.69,1.69,0,0,0,8,12.6h.242V11.387a1.208,1.208,0,0,0-.574-1.025l.018-.015a1.059,1.059,0,0,0,.3-.656h.849l.413.619.4-.269-.556-.835H7.985a1.056,1.056,0,0,0-.165-.485,1.056,1.056,0,0,0,.165-.485h.849l.413.619.4-.269-.556-.835H7.985a1.052,1.052,0,0,0-.206-.537.727.727,0,0,0,.458-.674V6.3h1.7a3.15,3.15,0,0,0,3.15-3.15A3.09,3.09,0,0,0,11.131.266ZM6.784,14.537H6.3v-.969h.485ZM5.33,5.3a1.7,1.7,0,0,1,.393-1.086l.607-.728a.275.275,0,0,1,.423,0l.607.728A1.7,1.7,0,0,1,7.753,5.3V6.541a.243.243,0,0,1-.242.242H5.572a.243.243,0,0,1-.242-.242ZM7.339,7.44a.58.58,0,0,1,.171.413v.284a.585.585,0,0,1-.585.585H6.157a.585.585,0,0,1-.585-.585V7.853a.585.585,0,0,1,.585-.585h.768a.581.581,0,0,1,.414.172Zm.171,1.867v.284a.585.585,0,0,1-.585.585H6.157a.585.585,0,0,1-.585-.585V9.307a.58.58,0,0,1,.056-.245,1.059,1.059,0,0,0,.529.145h.768a1.059,1.059,0,0,0,.529-.145A.58.58,0,0,1,7.511,9.307ZM3.15,5.815A2.665,2.665,0,0,1,.485,3.15,2.607,2.607,0,0,1,2.132.717L2.665.5v.828a2.494,2.494,0,0,0-.931,1.4L1.7,2.848l.47.118L2.2,2.844A2.012,2.012,0,0,1,2.983,1.7H3.15v1.31a1.212,1.212,0,0,1-.16.6L2.212,4.967l.421.24.207-.362h.89a1.385,1.385,0,0,1,1.116.565v.4Zm2.18,6.275v-.7a.728.728,0,0,1,.727-.727H6.3V10.9A1.213,1.213,0,0,1,5.33,12.089Zm1.7-1.429a.728.728,0,0,1,.727.727v.7A1.213,1.213,0,0,1,6.784,10.9V10.66Zm4.507-5.379a2.683,2.683,0,0,1-1.6.533h-1.7v-.4a1.385,1.385,0,0,1,1.116-.565h.89l.207.362.421-.24-.777-1.361a1.213,1.213,0,0,1-.16-.6V1.7H10.1a2.012,2.012,0,0,1,.779,1.149l.031.122.47-.118-.031-.121a2.493,2.493,0,0,0-.931-1.4V.5l.533.213A2.608,2.608,0,0,1,12.6,3.149a2.678,2.678,0,0,1-1.066,2.132Zm0,0"
            transform="translate(0 0)"
          />
          <path
            id="Trazado_9103"
            data-name="Trazado 9103"
            d="M192.485,160.242a.242.242,0,1,1-.242-.242A.242.242,0,0,1,192.485,160.242Zm0,0"
            transform="translate(-186.185 -155.154)"
          />
          <path
            id="Trazado_9104"
            data-name="Trazado 9104"
            d="M224.485,160.242a.242.242,0,1,1-.242-.242A.242.242,0,0,1,224.485,160.242Zm0,0"
            transform="translate(-217.216 -155.154)"
          />
        </g>
      </g>
    </SvgWrapper>
  );
};

export default CrustaceanIcon;
